import request from "@/utils/request";

const obj = {
    adminEditMemberMonthlyEndLine(data) {
        return request.post(`/device/memberMonthly/agentEditMemberMonthlyEndLine`, data)
    }

};
export default obj;
